export enum DuvodZruseniSubjektu {
	NA_ZAKLADE_ZADOSTI_ZADAVATELE = 'NA_ZAKLADE_ZADOSTI_ZADAVATELE',
	PORUSENI_PROVOZNIHO_RADU = 'PORUSENI_PROVOZNIHO_RADU',
	JINE = 'JINE'
}
